import React from 'react';
import { SearchInput } from '@mds/ui';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export interface AdminListToolbarButton {
    selected: boolean;
    onClick: () => void;
    label: string;
}

export interface AdminListToolbarProps {
    filterItems?: AdminListToolbarButton[];
    searchString: string;
    toolbarPlaceholder: string;
    searchSx?: SxProps<Theme>;
    onQueryStringChange: (value: string) => void;
}

const AdminListToolbar = ({
    filterItems,
    onQueryStringChange,
    toolbarPlaceholder,
    searchString,
    searchSx,
}: AdminListToolbarProps): JSX.Element => {
    const isNoFilterItems = !filterItems;
    const searchInputSx = [
        { width: isNoFilterItems ? '100%' : { xs: '100%', md: 320 } },
        ...(Array.isArray(searchSx) ? searchSx : searchSx ? [searchSx] : []),
    ];

    return (
        <Stack
            id="admin-list-toolbar"
            direction={{ xs: 'column', md: 'row' }}
            spacing={1}
            sx={{
                alignItems: { xs: 'stretch', md: 'center' },
                justifyContent: 'space-between',
            }}
        >
            {filterItems && (
                <ToggleButtonGroup
                    exclusive
                    size="medium"
                    value={filterItems.findIndex((item) => item.selected)}
                    aria-label="List filter"
                    onChange={(_, nextValue: number | null) => {
                        if (nextValue !== null)
                            filterItems[nextValue]?.onClick();
                    }}
                    sx={{
                        flexWrap: 'wrap',
                        width: 'fit-content',
                        maxWidth: '100%',
                    }}
                >
                    {filterItems.map(
                        (item: AdminListToolbarButton, i: number) => (
                            <ToggleButton key={item.label} value={i}>
                                {item.label}
                            </ToggleButton>
                        )
                    )}
                </ToggleButtonGroup>
            )}
            <SearchInput
                id="admin-list-search-input"
                autoComplete="off"
                fullWidth={isNoFilterItems}
                placeholder={toolbarPlaceholder}
                value={searchString}
                onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                ): void => {
                    onQueryStringChange(event.target.value);
                }}
                sx={searchInputSx}
            />
        </Stack>
    );
};

export default AdminListToolbar;
